import React, {useState} from 'react'
import { Container, Row, Col, Form } from 'react-bootstrap'
import { LuMapPin } from "react-icons/lu";
import { FiPhone } from "react-icons/fi";
import { HiOutlineMail } from "react-icons/hi";
import { useMediaQuery } from 'react-responsive';
import useFormvalidation from '../../validations/FormValidation' 
import { ContactFormRules } from "../../validations/FormValidationRules";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from"moment";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaRegCalendar } from "react-icons/fa";
import Apis from '../../services/Apis'
import ContactForm from './ContactForm';


const Contact = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
    
    
    return (
        <div className='contact-section' id="contact-section">
            <Container className={`${isMobile ? 'mb-5' : ''}`}>
                <Row className='w-100'>
                    <Col lg={6} md={12} xs={12} style={{ marginBottom : isMobile ? '12%' : '', padding: isMobile ? '10% 0% 10% 14%': ''}}>
                        <div>
                            <h3>Get in Touch</h3>
                            <h6 className='text-capitalize'>Are you ready to transform your vision into reality? Partner with VeeraSynergies Pvt. Ltd. for world-class solutions tailored to your needs.</h6>

                        </div>

                    </Col>
                    <Col lg={6} md={12} xs={12} style={{ paddingLeft : '6%'}}>
                        <div className='d-flex'>
                            <div className='contact-icon'>
                                <button>
                                    <LuMapPin size={25} />
                                </button>
                            </div>
                            <div className='contact-address'>
                                <p>Location:</p>
                                <span>VeeraSynergiesPvt. Ltd, D.No.60-9-10, Unit No.2,</span><br/>
                                <span className='s2'>GEV Radha Madhav Apartment, </span><br/>
                                <span className='s2'>Moghalrajpuram, Vijayawada (Urban),</span><br/>
                                <span className='s2'> Krishna- 520010, Andhra Pradesh</span><br/>
                            </div>
                        </div>
                        <div className='d-flex mt-5'>
                            <div className='d-flex' style={{ marginRight : '7%'}}>
                                <div className='contact-icon'>
                                    <button>
                                        <FiPhone size={25} />
                                    </button>
                                </div>
                                <div className='contact-address'>
                                    <span>Call Us:</span><br />
                                    <span>+91 9949070001</span>
                                </div>
                            </div>
                            {
                                  !isMobile &&
                                  <div className='d-flex'>
                                  <div className='contact-icon'>
                                      <button>
                                          <HiOutlineMail size={25} />
                                      </button>
                                  </div>
                                  <div className='contact-address'>
                                      <span>Email:</span><br />
                                      <span>info@veerasynergies.com</span>
                                  </div>
                              </div>
                            }
                           
                        </div>
                        {
                            isMobile &&
                            <div className='d-flex mt-5'>
                            <div className='contact-icon'>
                                <button>
                                    <HiOutlineMail size={25} />
                                </button>
                            </div>
                            <div className='contact-address'>
                                <span>Email:</span><br />
                                <span>info@veerasynergies.com</span>
                            </div>
                        </div>
                        }
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Contact
